module.exports = __webpack_public_path__ + "img/industriale_idle.e096c23c.png";